import { useIntl } from 'react-intl';
import {
  AuthoredEvidence,
  TableCells,
  TableColumn,
  TableFilterCells,
} from '@eas/common-web';
import { ResearchQuery } from '@models';
import { useResearchQueryType } from './research-query-api';

export function useColumns(): TableColumn<ResearchQuery>[] {
  const intl = useIntl();
  const { authoredColumns } =
    AuthoredEvidence.useAuthoredColumns<ResearchQuery>();

  return [
    {
      datakey: 'ipAddress',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__IP_ADDRESS',
        defaultMessage: 'IP Adresa',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'type',
      filterkey: 'type.id',
      sortkey: 'type.name',
      name: intl.formatMessage({
        id: 'IP__FAQS__COLUMN__TYPE',
        defaultMessage: 'Typ',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterSelectCellFactory(useResearchQueryType),
      valueMapper: TableCells.useSelectCellFactory(useResearchQueryType),
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'executed',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__EXECUTED',
        defaultMessage: 'Vykonáno',
      }),
      width: 150,
      CellComponent: TableCells.DateTimeCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'duration',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__DURATION',
        defaultMessage: 'Doba trvání',
      }),
      width: 150,
      CellComponent: TableCells.NumberCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'success',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__SUCCESS',
        defaultMessage: 'Úspěšné',
      }),
      width: 150,
      CellComponent: TableCells.BooleanCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'resultsCount',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__RESULTS_COUNT',
        defaultMessage: 'Počet výsledků celkem',
      }),
      width: 150,
      CellComponent: TableCells.NumberCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'page',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__PAGE',
        defaultMessage: 'Stránka',
      }),
      width: 80,
      CellComponent: TableCells.NumberCell,
    },
    {
      datakey: 'pageSize',
      name: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERY__COLUMN__PAGE_SIZE',
        defaultMessage: 'Počet výsledků na stránce',
      }),
      width: 150,
      CellComponent: TableCells.NumberCell,
    },

    /*     {
      datakey: 'tags',
      sortkey: 'tags.concatenated',
      filterkey: 'tags.id',
      name: intl.formatMessage({
        id: 'IP__FAQS__COLUMN__TAGS',
        defaultMessage: 'Klíčová slova',
      }),
      width: 200,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterAutocompleteCellFactory(useTags),
      valueMapper: localizedDictionaryArrayColumnMapper,
      sortable: true,
      filterable: true,
    }, */

    ...authoredColumns,
  ];
}
